import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../component/common/Button";
import Input from "../../../component/common/Input";
import { useUser } from "../../../context/UserContext";
import { useFormContext } from "react-hook-form";

const ForCorporate = () => {
  const navigate = useNavigate();
  const { setUser } = useUser();
  const {
    register,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    clearErrors();
  }, []);

  // const onSubmit = (data) => {
  //   console.log(data); // You can log form data to check if it's being captured properly
  //   setUser(true);//   setUser(true);
  //   navigate("/"); // Navigate to homepage or desired route
  // };

  return (
    <div className="flex items-center justify-center min-h-screen bg-white p-[20px] sm:p-10">
      <div className="card w-[491px] p-[20px] sm:p-[40px]">
        <h1 className="heading">Register as Corporate 🎟️</h1>
        <p className="paragraph">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis morbi
          pulvinar venenatis non.
        </p>

        {/* Full Name Input */}
        <div>
          <Input
            label={"What's your name"}
            placeholder={"Your Full name"}
            {...register("name")} // Connect input with react-hook-form
          />
          {errors.name && (
            <p className="text-red-500 text-sm mt-1">{errors.name.message}</p>
          )}
        </div>

        {/* Job Title Input */}
        <div>
          <Input
            label={"Job Title"}
            placeholder={"Enter Job Title"}
            {...register("jobTitle")} // Connect input with react-hook-form
          />
          {errors.jobTitle && (
            <p className="text-red-500 text-sm mt-1">
              {errors.jobTitle.message}
            </p>
          )}
        </div>

        {/* TAN Number Input */}
        <div>
          <Input
            label={"TAN Number"}
            placeholder={"Your TAN number"}
            {...register("tanNumber")} // Connect input with react-hook-form
          />
          {errors.tanNumber && (
            <p className="text-red-500 text-sm mt-1">
              {errors.tanNumber.message}
            </p>
          )}
        </div>

        {/* Submit Button */}
        <Button
          content="Sign In"
          classes="mt-[41px] w-full text-base hover:bg-[#3872A5] duration-300 justify-center"
          type="submit" // Ensure button submits the form
        />
      </div>
    </div>
  );
};

export default ForCorporate;
